import { SubscriptionPlan } from '@modules-deprecated/app/organization/enums/subscriptionPlan'

import type { BackToSchoolAudience } from '../types/backToSchoolAudience'

interface GetBackToSchoolAudienceParams {
  consolidatedBilling: boolean
  isExpiredTrial: boolean
  isLocked?: boolean
  isLoading: boolean
  isOrganizationOwner: boolean
  isTrialNoPlanSelected: boolean
  market?: string | null
  remainingCampaignDays: number
  subscriptionPlan?: SubscriptionPlan
}

export const getBackToSchoolAudience = ({
  consolidatedBilling,
  isExpiredTrial,
  isLocked,
  isLoading,
  isOrganizationOwner,
  isTrialNoPlanSelected,
  market,
  remainingCampaignDays,
  subscriptionPlan,
}: GetBackToSchoolAudienceParams): BackToSchoolAudience => {
  if (
    remainingCampaignDays === 0 ||
    market !== 'fr' ||
    isLoading ||
    (isLocked && !isExpiredTrial) ||
    consolidatedBilling ||
    !isOrganizationOwner
  ) {
    return null
  }
  if (isExpiredTrial) {
    return 'expired_trial'
  }
  if (isTrialNoPlanSelected) {
    return 'trial'
  }
  if (subscriptionPlan === SubscriptionPlan.Free) {
    return 'free'
  }
  return null
}
